// AWS Firehose
export { destinationFirehose } from './firehose';
export * as DestinationFirehose from './firehose/types';

// Examples
export * as destinationFirehoseExamples from './firehose/examples';
